/**
 * 高级检索路由
 * 2017-12-4
 * Bai.Zhiming
 */
'use strict';
angular.module('resourceCenterGlobalSearchRouterModule', []).
    config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('globalSearch', { 
            url: '/globalSearch?keyWords', // 携带的搜索关键词
            views: {
                '': {
                    templateUrl: './resourceCenter/resAdvancedSearch/globalSearch/globalSearch.html',
                    controller: 'resourceCenterGlobalSearchCtrl'
                },
            }
        });
    }]);